<template>
    <div class="employee-tab-inner">
        <!--<ul class="list-group mb-3 " v-if='errormsg'>
            <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
        </ul>-->
        <b-overlay :show="showoverlay" rounded="sm">
             <div class="pf-reporting-tab payroll-reporting-tab trz_pf_loan_tab  pf_loan_tab_new" id="nav-tabContent-intro4">

                <b-tabs content-class="mt-3 reports-tab-wrapper" nav-wrapper-class="mb-2 mt-2 reports-tab-nav" v-if="$acl['pf/allloanapplications'] > 0">

                        <input type="hidden" v-model="fdata.employee_id" name="employee_id">
                        <b-tab active>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/PF_Loan_Management.png'" class="light-mode-icon" /><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" />
                                    <h5>View Application(s)</h5>
                                    <p>Process advance applications</p>
                                    <b-button class="btn btn-primary">View</b-button> <!-- Mustafijur: 23-05-2026: View Report to View -->
                                </div>

                            </template>
                             <div class="">
                            <div class="col-12 text-right pr-0">
                             <b-button v-if="$acl['pf/allloanapplications'] > 1" class="mb-1 w-100" @click="addNew()" style="max-width: 325px;">Add Advance</b-button>
                            </div>
                            <pf-loan-applications :pageurl="this.$api_url"  :key="this.init_flg" :flg="this.init_flg" ></pf-loan-applications>
                            </div>
                        </b-tab>
                        <template v-if="$acl['pf/allloanapplications'] > 1">
                        <b-tab lazy>

                             <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/PF_Loan_Management.png'" class="light-mode-icon" /><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" />
                                    <h5>Process Advance</h5>
                                    <p> Process new advance for employee</p>
                                    <b-button class="btn btn-primary">View</b-button> <!-- Mustafijur: 23-05-2026: View Report to View -->
                                </div>

                            </template>
                                <div class="">
                                    <div class="col-12 text-right pr-0"><b-button v-if="$acl['pf/allloanapplications'] > 1" class="mb-1 w-100" @click="addNew()" style="max-width: 325px;">Add Advance</b-button></div>

                                    <div class="" >
                                        <div v-if="custom_list.length>0">

                                            <!-- <div class="col-sm-6 pl-0" >
                                            <div class="employee-btn-holder" style="max-width:260px" >
                                                <div class="report-intro" style="text-align:left">
                                                    Bulk Import
                                                </div>
                                                <div  style="min-height:5px;">
                                                </div>

                                                <b-button @click="exportPFSelected" ><b-icon icon="code-slash" ></b-icon> Template</b-button>
                                                <b-button :href="$api_url+'/pf/loan/import/add'"><b-icon icon="box-arrow-up" class="" scale="1"></b-icon> Import</b-button>

                                            </div>
                                            </div> -->
                                            <common-list  :pageurl="this.$api_url"  :is_action="is_action" :checkbox="checkbox" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" is_pf="1" v-on:childToParent="listReturn"></common-list>
                                        </div>
                                        <div v-else class="mb-3 pb-3"> <!-- Mustafijur: 23-05-2026: added mb-3 pb-3 -->
                                            <div v-if="show_loader" class="list-no-data">
                                                <span class="d-block text-center">Looking for relevant data..</span>
                                                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                                            </div>
                                            <div v-else class="list-no-data">
                                                Looks like there is no employee to show.
                                            </div>
                                        </div>
                                    </div>
                                </div>


                        </b-tab>
                        </template>
                        <template v-if="$acl['pf/allloanapplications'] > 1">
                            <b-tab lazy>
                                <template #title>
                                    <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                        <img v-bind:src="$api_url+'/images/PF_Loan_Management.png'" class="light-mode-icon" /><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" />
                                        <h5>Employee Advance Profile</h5>
                                        <p>Individual employee's advance history</p>
                                        <b-button class="btn btn-primary">View</b-button> <!-- Mustafijur: 23-05-2026: View Report to View -->
                                    </div>

                                    <!-- <div class="report-title w-100 border-bottom font-weight-bold pb-2 mb-2">
                                        <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>Employee Advance Profile
                                    </div>
                                    <div class="report-intro">
                                        Individual employee's advance history
                                    </div>
                                    <b-button class="mt-3">View</b-button> -->
                                </template>
                                <div class="">
                                    <pf-loan-profile-list :pageurl="this.$api_url"  :key="this.init_flg" ></pf-loan-profile-list>
                                </div>
                            </b-tab>
                        </template>
                        <b-tab lazy v-if="$site_options && $site_options['pf_advance_awaiting_disbursement'] == 1">
                            <template #title>

                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/PF_Loan_Management.png'" class="light-mode-icon" /><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" />
                                    <h5>Advance Awaiting for Disbursement</h5>
                                    <p>Advance Awaiting for Disbursement</p>
                                    <b-button class="btn btn-primary">View</b-button> <!-- Mustafijur: 23-05-2026: View Report to View -->
                                </div>
                                <!-- <div class="report-title w-100 border-bottom font-weight-bold pb-2 mb-2">
                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>Advance Awating for Disbursment
                                </div>
                                <div class="report-intro">
                                    Advance Awating for Disbursment
                                </div>
                                <b-button class="mt-3">View</b-button> -->
                            </template>
                            <div class="">
                                <pf-loan-applications-disbursement :pageurl="this.$api_url"  :key="this.init_flg" :flg="this.init_flg" ></pf-loan-applications-disbursement>
                            </div>
                        </b-tab>

                        <!-- Start: Rejwan: 08-04-2026 Early loan settlement -->
                         <b-tab lazy>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>Advance Awaiting for Early Settlement</h5>
                                    <p>Advance Awaiting for Early Settlement</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>
                            </template>
                            <div class="">
                                <pf-loan-early-settlement-list :pageurl="this.$api_url"  :key="this.init_flg" :flg="this.init_flg" ></pf-loan-early-settlement-list>
                            </div>
                        </b-tab>
                        <!-- End: Rejwan: 08-04-2026 Early loan settlement -->
                    <!-- Form ends here -->
                </b-tabs>
            </div>
        </b-overlay>
        <b-modal id="bv-modal-process-loan" size="lg" hide-footer v-bind:title="modal_title">
            <pf-loan-form-new :pageurl="this.$api_url" :flg="this.init_flg" :employee_id="curr_process_id" v-on:childToParent="updateTransactions" :employee_name="curr_process_name" :key="count" :count="count" :loan_id="loan_id" :is_custom="is_custom" :is_status="is_status"></pf-loan-form-new>
        </b-modal>
        <b-modal id="bv-modal-employee" size="lg" hide-footer v-bind:title="modal_title">
            <search-employee-pf :pageurl="this.$api_url" :is_loan="1" v-on:childToParent="setEmployee"></search-employee-pf>
        </b-modal>




    </div>




</template>

<script>

    import myUpload from 'vue-image-crop-upload';
    import moment from 'moment';
    export default{

        mounted() {

            this.showoverlay = false;
        },
        props: ['pageurl' , 'flg'],
        components: {
           'my-upload': myUpload,
        },
        data(){

            return {
                loans:[],
                checkbox:1,
                loan_id:'',
                is_custom:'',
                is_status:'',
                cu:window.location.href,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                showoverlay : true,
                show_loader : true,
                errormsg:[],

                fdata: {

                        },

                xdata : {

                },
                show_bank_preview:false,
                pgurl:this.$api_url,
                new_capability:true,

                /* new variables*/
                selected: [],
                emp_list_data : [],
                application_lists: [],
                people:0,
                search:'',
                length: 10,
                length_options: [{ value: 10, text: "10" },{ value: 20, text: "20" },{ value: 30, text: "30" },{ value: 40, text: "40" },{ value: 50, text: "50" }],
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                curr_process_id: 0,
                curr_process_name: '',
                count:'',
                modal_title:'',
                init_flg : 0,
                /**Child Component property data */
                is_action:1, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                custom_list:[],  /* Data List */
                default_column:['name','email','jobposition','department'], /* Default Column List */
                appended_column:[],                   /* Appended Column List  and there title and type */
                primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked,
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */

                tmp_custom_list:[],

                custom_array:[],

                /***Child Component property data */
                preview_list:[],
            }
        },
        methods:{
            formatMe(d)
            {
                return moment(d).format('DD/MM/YYYY');
            },
            addNew: function()
            {
                this.modal_title = "Employee List";
                this.$bvModal.show('bv-modal-employee');
            },
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }

            //     return money;
            // },
            previewBankFile: function()
            {
                if(!this.checkNet()) return false;

                let url = ''

                url = this.$api_url + '/pf/loan/disburse/preview-bank-file';

                let formData = new FormData();

                let currentObj = this;
                axios.post(url, formData).then(function (response)
                {

                    if(response.data.errors)
                    {
                        this.preview_list = [];
                    }
                    else
                    {
                        this.preview_list = response.data;
                        console.log(this.preview_list);
                        this.modal_title = "Bank File Preview";
                        this.$bvModal.show('bv-modal-bank-file-preview');
                    }


                }.bind(this))
                .catch(error => {
                    if(error.response){


                    }
                });
                return false;
            },
            updateTransactions(x)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;

                axios.get(this.$api_url+'/pf/loan/updatetransactions', {
                    params: {
                        loan_type: 1
                    }
                }).then(function(response){
                    this.$bvModal.hide('bv-modal-process-loan');
                    this.init_flg = this.init_flg + 1;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            setEmployee: function(data)
            {
                this.curr_process_name = data['name'];
                this.curr_process_id = data['id'];
                this.modal_title = "Process PF Advance";
                //alert(emp_name);
                if(this.curr_process_name.length >0)
                this.modal_title += " for "+this.curr_process_name;

                this.count = this.count + 1;
                this.$bvModal.hide('bv-modal-employee');
                this.$bvModal.show('bv-modal-process-loan');
            },
            maxStartDate: function() {
                return moment()
                    .startOf('month')
                    .add(1, 'months')
                    .endOf('month').format('DD/MM/YYYY');
            },
            showMessage: function()
            {
                let childdata = {employee_id:this.fdata.employee_id , successmsg:this.successmsg , warningmsg:this.warningmsg , dangermsg:this.dangermsg};
                this.$emit('childToParent', childdata);
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.fdata = {
                };

                this.reset_flg = true;

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            processLoan(emp_id,emp_name)
            {
                this.modal_title = "Process PF Advance";
                if(emp_name.length >0)
                this.modal_title += " for "+emp_name;

                this.curr_process_id = emp_id;
                this.curr_process_name = emp_name;
                this.$bvModal.show('bv-modal-process-loan');
            },
            listReturn:function(data)
            {

                if(data.selected.length > 0)
                {
                    this.selected = data.selected;
                }
                else
                {
                    this.selected = [];

                }
                if(data.employee_id && data.action_id==1)
                {
                    this.processLoan(this.custom_array[data.employee_id].employee_id,this.custom_array[data.employee_id].name);
                }


            },
            sendBankFile: function()
            {
                if(!this.checkNet()) return false;

                let url = ''

                url = this.$api_url + '/pf/loan/disburse/send-bank-file';



                // if(this.column_selected.indexOf('name') === -1){
                //     this.column_selected.unshift('name');
                // }

                let formData = new FormData();
                let currentObj = this;
                axios.post(url, formData).then(function (response)
                {

                    if(response.data.errors)
                    {

                    }
                    else
                    {

                    }


                }.bind(this))
                .catch(error => {
                    if(error.response){


                    }
                });
                return false;
            },
            exportPFSelected: function()
            {
                if(this.selected == '')
                this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else
                {
                    this.exportPF('selected');
                }

            },
            exportPF: function(sltd='')
            {

                this.$bvToast.toast('It might take a while', {
                                        title: `Info`,
                                        variant: 'info',
                                        solid: true
                                    });
                console.log(this.selected);

                this.showoverlay = true;
                let formData = new FormData();
                if(sltd.length>0 && this.selected)
                formData.append('employee_ids', this.selected);

                this.downloadBlobResponse(
                    axios.post(this.$api_url + '/pf/loan/export/add', formData, { responseType: 'blob' }),
                    'showoverlay' // your loader key in this component
                );

            },
            getPfEmployeeListData: function(){
            let currentObj = this;
            this.showoverlay = true;
            this.show_loader = true;
              axios.get(this.$api_url+'/pf/loan/eligible-employee-list', {
                 params: {
                        pf_loan:1,
                    }
                    })
              .then(function (response) {
                 this.showoverlay = false;

                    /* Assingning the Options */

                    this.company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));

                    /* Assingning the list */
                    this.tmp_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

                    /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */

                    if(this.tmp_custom_list.length > 0 )
                    {
                        this.tmp_custom_list.forEach(element => {
                                if(element.employee_id > 0)
                                {

                                    this.custom_array[element.employee_id] = element;
                                    let dop = [];
                                    /*  If DropDown type one is First Choice */

                                        dop = dop.concat([{ label: 'Process Advance' , value: 1 }]);

                                    /* Action for all column **/

                                    element.actions = dop;
                                }
                            });

                    }

                    this.custom_list = this.tmp_custom_list;
                    this.show_loader = false;
                    console.log(this.custom_list);
                    this.list_key = this.list_key + 1;
              }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});

            },
        },
        created: function(){
            if(!this.checkNet()) return false;
            this.$validator.reset();

            if(this.$acl['pf/allloanapplications'] > 0)
            {
                this.getPfEmployeeListData();
                this.updateTransactions(1);
            }

        }
    }
</script>
<style>
/* #nav-tabContent-intro4.payroll-reporting-tab.pf_loan_tab_new .nav-item {
	width: 24% !important;
    margin-right: 1%;
}  */
.table-wrapper-bank-preview
{
    overflow-x:scroll;
}
</style>
